import { createContext, useContext } from 'react';
import doNothing from '../../lib/doNothing';
import { IEntity } from '../../types/api/entities/IEntity';

export type SocketEventHandler<T extends IEntity> = (...args: [eventContent: T, eventType?: string]) => void;

export type Destructor = () => void;

export type WebSocketSubscribe<T extends IEntity = any> = (
  event: string,
  callback: SocketEventHandler<T>,
) => Destructor;

export const SocketManagerContext = createContext<WebSocketSubscribe>((..._) => doNothing);

export const useWebSockets = <T extends IEntity = any>() => {
  const subscribe = useContext(SocketManagerContext);
  return subscribe as WebSocketSubscribe<T>;
};
